module.exports = __webpack_public_path__ + "img/mobile-3.65521316.png";